'use client';

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

type SavedJobToastActionProps = {
  onDismiss: () => void;
};

export function SavedJobToastAction({ onDismiss }: SavedJobToastActionProps) {
  return (
    <Link
      href="/viec-da-luu"
      onClick={onDismiss}
      className="leading-sm ml-6 inline-flex shrink-0 items-center gap-1 text-sm font-medium text-[var(--tailwind-colors-green-500)] hover:text-[var(--tailwind-colors-green-800)]"
    >
      Xem việc đã lưu
      <ArrowRight className="size-4" aria-hidden />
    </Link>
  );
}
